import { action, thunk, persist } from 'easy-peasy';

const model = {
  loading: false,
  setLoading: action((state, payload) => {
    state.loading = payload
  }),
  objects: [
    /*
    {id: 1, name: "Osake A"},
    {id: 2, name: "Osake B"},
    {id: 3, name: "Osake C"},
    */
  ],
  setObjects: action((state, payload) => {
    if (payload) {
      state.objects = [
        ...payload,
      ]
    }
  }),
  addObject: action((state, payload) => {
    state.objects = [
      ...state.objects,
      payload,
      // loggedIn: true,
    ]
  }),
  getObjects: thunk(async (actions, payload) => {
    actions.setLoading(true)
    
    // Placeholder implementation since basic_data endpoint is no longer available
    console.log("purchases.getObjects called - basic_data endpoint removed");
    
    // Set empty data
    actions.setObjects([]);
    actions.setLoading(false);
  }),

  count: 0,
  setCount: action((state, payload) => {
    state.count = payload
  }),
  
};

export default model;